import Icon, { IconButton } from "@xo-union/tk-component-icons";
import { H4 } from "@xo-union/tk-ui-typography";
import React from "react";
import styles from "./header.css";
import { isKeyEnterSpace } from "./helpers.js";
export var Header = function Header(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    _ref$leftIconName = _ref.leftIconName,
    leftIconName = _ref$leftIconName === void 0 ? 'back' : _ref$leftIconName,
    leftButtonText = _ref.leftButtonText,
    leftButtonOnClick = _ref.leftButtonOnClick,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? '' : _ref$as,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Close' : _ref$closeButtonAriaL;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.containerLeft
  }, leftButtonText && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: styles.back,
    onKeyDown: function onKeyDown(e) {
      if (isKeyEnterSpace(e) && typeof leftButtonOnClick === 'function') {
        e.preventDefault(); // So the page behind doesn't scroll if you hit the spacebar to go back.
        leftButtonOnClick();
      }
    },
    onClick: leftButtonOnClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: leftIconName,
    size: "md"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.buttonText
  }, leftButtonText)), children && /*#__PURE__*/React.createElement(H4, {
    as: as
  }, children)), /*#__PURE__*/React.createElement("div", null, onClose && /*#__PURE__*/React.createElement(IconButton, {
    className: styles.close,
    "data-testid": "close-icon",
    name: "close",
    size: "md",
    onClick: onClose,
    "aria-label": closeButtonAriaLabel
  })));
};